import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./style.css";

export default function TaggedFriendsModal({ taggedFriends, onClose }) {
  const popRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (popRef.current && !popRef.current.contains(e.target)) {
        onClose?.();
      }
    };
    const onEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [onClose]);

  if (!taggedFriends || taggedFriends.length === 0) {
    return null;
  }

  return (
    <div className="tagged_friends_popover" ref={popRef} role="dialog" aria-label="Tagged friends">
      <div className="tagged_friends_list">
        {taggedFriends.map((friend) => (
          <Link
            key={friend._id}
            to={`/profile/${friend.username}`}
            className="tagged_friend_item"
            onClick={onClose}
          >
            <div className="tagged_friend_avatar">
              <img
                src={friend.picture}
                alt="profile"
                className="tagged_friend_picture"
              />
            </div>
            <div className="tagged_friend_info">
              <span className="tagged_friend_username">@{friend.username}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
} 